/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Audit_Details_Private_Model_Added_DescInputs */



/**
* | output |
* | --- |
* | "The self-hosted model \"{model}\" was added, so requests can now be routed to your own endpoint." |
*
* @param {Audit_Details_Private_Model_Added_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_private_model_added_desc = /** @type {((inputs: Audit_Details_Private_Model_Added_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Private_Model_Added_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das selbst gehostete Modell "${i?.model}" wurde hinzugefügt. Anfragen können jetzt an den eigenen Endpunkt geleitet werden.`)
	return /** @type {LocalizedString} */ (`The self-hosted model "${i?.model}" was added, so requests can now be routed to your own endpoint.`)
});